jQuery(document).ready(function ($) {
    function fetch_experiences($block, page, category, append) {
        const $grid = $block.find('[data-experiences-grid]');
        const $load_more = $block.find('[data-experiences-load-more]');

        $load_more.prop('disabled', true);
        show_loading_overlay();

        return $.post(blogs.ajax_url, {
            action: 'load_more_experiences',
            nonce: blogs.nonce,
            page: page,
            category: category
        }).done(function (response) {
            if (!response.success) {
                return;
            }

            if (append) {
                $grid.append(response.data.html);
            } else {
                $grid.html(response.data.html);
            }

            $load_more.data('page', response.data.current_page);
            $load_more.data('category', category);

            $load_more.prop('hidden', response.data.current_page >= response.data.max_pages);
        }).always(function () {
            $load_more.prop('disabled', false);
            hide_loading_overlay();
        });
    }

    $('[data-experiences-load-more]').on('click', function () {
        const $button = $(this);
        const $block = $button.closest('.experiences');

        const next_page = parseInt($button.data('page'), 10) + 1;
        const category = $button.data('category') || 'all';

        fetch_experiences($block, next_page, category, true);
    });

    $('[data-experiences-filter]').on('click', function () {
        const $button = $(this);
        const $block = $button.closest('.experiences');

        if ($button.is('[data-active]')) {
            return;
        }

        $block.find('[data-experiences-filter]').removeAttr('data-active');
        $button.attr('data-active', '');

        const category = $button.data('term-id') || 'all';

        fetch_experiences($block, 1, category, false);
    });
});
